import * as React from 'react';
// icons
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
// dayjs
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);
// types
import Task from '../../interfaces/Task.interface';
import Event from '../../interfaces/Event.interface';
import RecurringTask from '../../interfaces/RecurringTask.interface';

interface TaskItemContentDateProps {
  itemData: Task | Event | RecurringTask;
  itemType: 'task' | 'event' | 'recurring';
  forceGrey?: boolean;
  padLeft?: boolean;
}

export default function ItemContentDate(props: TaskItemContentDateProps) {
  const itemData: Task | Event | RecurringTask = props.itemData;
  const itemType = props.itemType;
  const padLeft = props.padLeft || false;
  const forceGrey = props.forceGrey || false;

  const determineDateStringAndColor = (targetLocalDate: Dayjs) => {
    const today: Dayjs = dayjs(); // local time "now"
    const diffInDays: number = targetLocalDate.startOf('day').diff(today.startOf('day'), 'day');
    let dateString = '';
    let color = '';
  
    if (diffInDays < 7) {
      if (diffInDays === -1) {
        dateString = 'Yesterday';
        color = '#ff7961';
      } else if (diffInDays < 0) {
        dateString = dayjs(targetLocalDate).format('MMM D');
        color = '#ff7961';
      } else if (diffInDays === 0) {
        dateString = 'Today';
        color = '#556cd6';
      } else if (diffInDays === 1) {
        dateString = 'Tommorrow';
        color = '#7986cb';
      } else {
        const dayName = dayjs(targetLocalDate).format('dddd');
        dateString = dayName;
      }
    } else {
      dateString = dayjs(targetLocalDate).format('MMM D');
    }

    if (today.year() !== targetLocalDate.year()) {
      dateString += ', '+targetLocalDate.year();
    }
  
    if (itemData.completed || (itemData as RecurringTask).permanentlyCompleted || forceGrey) {
      color = '';
    }

    return { color, dateString };
  }

  const isFullDaySpan = (start: dayjs.Dayjs, end: dayjs.Dayjs): boolean => {
    return start.isSame(start.startOf('day')) && end.isSame(start.endOf('day'));
  };

  let tempColor: string = '';
  let tempDateString: string = '';

  if (itemType === 'task') {
    const task: Task = itemData as Task;

    const dueDateLocal: Dayjs = dayjs.utc(task.dueDate).local();
    const dueDateStringAndColor = determineDateStringAndColor(dueDateLocal);
    tempColor = dueDateStringAndColor.color;
    tempDateString = dueDateStringAndColor.dateString;
  } else if (itemType === 'event') {
    const event: Event = itemData as Event;

    const startDateUTC: Dayjs = dayjs.utc(event.startTime);
    const endDateUTC: Dayjs = dayjs.utc(event.endTime);
    const startDateLocal: Dayjs = startDateUTC.local();
    const endDateLocal: Dayjs = endDateUTC.local();

    if (startDateLocal.isSame(endDateLocal, 'day')) {
      const dateStringAndColor = determineDateStringAndColor(startDateLocal);
      tempColor = dateStringAndColor.color;

      if (isFullDaySpan(startDateLocal, endDateLocal)) {
        tempDateString = dateStringAndColor.dateString;
      } else {
        tempDateString = `${dateStringAndColor.dateString} ${startDateLocal.format('HH:mm')} - ${endDateLocal.format('HH:mm')}`;
      }
    } else {
      const startStringAndColor = determineDateStringAndColor(startDateLocal);
      const endStringAndColor = determineDateStringAndColor(endDateLocal);
      tempColor = startStringAndColor.color;
      tempDateString = `${startStringAndColor.dateString} ${startDateLocal.format('HH:mm')} - ${endStringAndColor.dateString} ${endDateLocal.format('HH:mm')}`;
    }
  } else if (itemType === 'recurring') {
    const recurringTask: RecurringTask = itemData as RecurringTask;

    const nextDueDate: Dayjs = dayjs(recurringTask.dueDate);
    const dueDateStringAndColor = determineDateStringAndColor(nextDueDate);
    tempColor = dueDateStringAndColor.color;
    tempDateString = dueDateStringAndColor.dateString;
  }

  const dateString: string = tempDateString;
  const color: string = tempColor;

  return (
    <React.Fragment><span style={{ color: color }}>
      <CalendarTodayIcon sx={{
        height: '16px',
        width: '20px',
        marginBottom: '-3px',
        marginLeft: padLeft ? '4px' : '0px',
        mr: '2px'
      }} />{dateString}</span>
    </React.Fragment>
  )
}
